import { X, ExternalLink } from 'lucide-react';
import { useAppConfig } from '../context/AppConfigContext';

export default function AnnouncementBanner() {
  const { config, showBanner, bannerColorClass, dismissBanner } = useAppConfig();

  if (!showBanner) return null;

  return (
    <div className={`fixed top-0 left-0 right-0 z-[60] ${bannerColorClass}`}>
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium">
        <span className="flex-1 text-center leading-snug">
          {config.announcement_text}
          {config.announcement_link && (
            <a
              href={config.announcement_link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 ml-2 underline underline-offset-2 opacity-80 hover:opacity-100"
            >
              Learn more <ExternalLink className="w-3 h-3" />
            </a>
          )}
        </span>
        {config.announcement_dismissible && (
          <button
            onClick={dismissBanner}
            className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center hover:bg-black/10 transition"
            aria-label="Dismiss"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
    </div>
  );
}